import classNames from 'classnames';
import React from 'react';
import styles from './screen.module.scss';

type ScreenProps = { children: React.ReactNode };

/**
 * Screen
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const Screen: React.FC<ScreenProps> = ({ children }) => (
  <div className={styles.screen}>
    {children}
  </div>
);

type ContentProps = {
  children: React.ReactNode,
  noBottomPadding?: boolean,
  valignMiddle?: boolean
};

/**
 * A container for all content. Lives directly inside Screen.
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.noBottomPadding]
 * @param {boolean} [props.valignMiddle]
 * @returns {JSX.Element}
 */
export const Content: React.FC<ContentProps> = ({ children, noBottomPadding = false, valignMiddle = false }) => (
  <div className={classNames(
    styles.content,
    noBottomPadding ? styles.noBottomPadding : '',
    valignMiddle ? styles.valignMiddle : ''
  )}>
    {children}
  </div>
);
